import { Actions, ModalDialog } from 'core-components/library/modalDialog'

import { DialogHeader } from '../components/DialogHeader'
import { EditProfile } from '../components/EditProfile'
import { ContactRelinking } from '../ContactRelinking'
import { IContactEditDialogProps, IContactEditDialogState, ICurrentVariant } from '../models'
import VariantSelector from '../VariantSelector'

interface IDialogContentProps {
  state: IContactEditDialogState
  props: IContactEditDialogProps
  changeConfirmationDialog: () => void
  onSaveStatus: () => Promise<void>
  onRemoveRequest: () => Promise<void>
  closeDialogAsk: () => void
  onApply: (callOnUpdate?: boolean) => Promise<void>
  setIsLoading: (value: boolean) => void
  setTab: (value: number) => void
  onChangeField: (fieldName: string, value?: string | number | boolean, silent?: boolean) => void
  onChangeFieldInReplacementContact: (fieldName: string, value?: string | number | boolean) => void
  checkPhoneNumberValidation: (field: string) => void
  checkEmailValidation: (withUniq?: boolean) => Promise<void>
  checkFieldValidation: (field: string) => boolean | undefined
  changeCountyCode: () => void
  setContactSavedCodes: (value: { [type: string]: ICurrentVariant[] }) => void
  setValidation: (value: boolean) => void
  setChangeStatus: (value: boolean) => void
  setPreferredContact: ({ current }: { current: number }) => void
  setIsUpdateDataUserRights: (value: boolean) => void
  setIsUpdateDataCampaigns: (value: boolean) => void
  setIsUpdateDataTools: (value: boolean) => void
  setAskCloseDialog: (value: boolean) => void
}

export const DialogContent = ({
  state,
  props,
  changeConfirmationDialog,
  onSaveStatus,
  onRemoveRequest,
  closeDialogAsk,
  onApply,
  setIsLoading,
  setTab,
  onChangeField,
  onChangeFieldInReplacementContact,
  checkPhoneNumberValidation,
  checkEmailValidation,
  checkFieldValidation,
  changeCountyCode,
  setContactSavedCodes,
  setValidation,
  setChangeStatus,
  setPreferredContact,
  setIsUpdateDataUserRights,
  setIsUpdateDataCampaigns,
  setIsUpdateDataTools,
  setAskCloseDialog,
}: IDialogContentProps) => {
  const { entryIdItem, readOnly, tab, replacementContact } = state

  const updateContactSavedCodes = (newData: { [type: string]: ICurrentVariant[] }) => {
    if (JSON.stringify(state.contactSavedCodes) !== JSON.stringify(newData)) {
      setContactSavedCodes(newData)
    }
  }

  return (
    <>
      <DialogHeader
        state={state}
        props={props}
        changeConfirmationDialog={changeConfirmationDialog}
        closeDialogAsk={closeDialogAsk}
        onSaveStatus={onSaveStatus}
        onRemoveRequest={onRemoveRequest}
        onApply={onApply}
        setIsLoading={setIsLoading}
        setTab={setTab}
      />

      {tab === 0 && (
        <EditProfile
          contact={entryIdItem}
          onChangeField={onChangeField}
          checkPhoneNumberValidation={checkPhoneNumberValidation}
          checkEmailValidation={checkEmailValidation}
          contactEditDialogState={state}
          contactEditDialogProps={props}
          checkFieldValidation={checkFieldValidation}
          changeCountyCode={changeCountyCode}
          setValidation={setValidation}
          setChangeStatus={setChangeStatus}
          setPreferredContact={setPreferredContact}
        />
      )}
      {tab === 1 && (
        <>
          {' '}
          {props.dialogEntryId === 1 ? (
            <div>
              <br />
              <br />
              Please, save this contact firstly
            </div>
          ) : (
            <VariantSelector
              contactCodes={state.contactCodes['UserRights']}
              contactCodesRequests={state.contactCodesRequests['UserRights']}
              abilityValues={state.codesDictionary['UserRights']}
              savedData={state.contactSavedCodes['UserRights']}
              setSavedData={(newData: ICurrentVariant[]) => {
                const date = { ...state.contactSavedCodes }
                date['UserRights'] = [...newData]
                updateContactSavedCodes(date)
              }}
              setUpdateData={(e: boolean) => {
                setIsUpdateDataUserRights(e)
              }}
              contactId={String(props.dialogEntryId)}
              readOnly={readOnly}
              type={'UserRights'}
            />
          )}
        </>
      )}
      {tab === 2 && (
        <>
          {props.dialogEntryId === 1 ? (
            <div>
              <br />
              <br />
              Please, save this contact firstly
            </div>
          ) : (
            <VariantSelector
              contactCodes={state.contactCodes['Campaigns']}
              contactCodesRequests={state.contactCodesRequests['Campaigns']}
              abilityValues={state.codesDictionary['Campaigns']}
              savedData={state.contactSavedCodes['Campaigns']}
              setSavedData={(newData: ICurrentVariant[]) => {
                const date = { ...state.contactSavedCodes }
                date['Campaigns'] = [...newData]
                updateContactSavedCodes(date)
              }}
              setUpdateData={(e: boolean) => {
                setIsUpdateDataCampaigns(e)
              }}
              contactId={String(props.dialogEntryId)}
              readOnly={readOnly}
              type={'Campaigns'}
            />
          )}
        </>
      )}
      {tab === 3 && (
        <>
          {props.dialogEntryId === 1 ? (
            <div>
              <br />
              <br />
              Please, save this contact firstly
            </div>
          ) : (
            <VariantSelector
              contactCodes={state.contactCodes['Tools']}
              contactCodesRequests={state.contactCodesRequests['Tools']}
              abilityValues={state.codesDictionary['Tools']}
              savedData={state.contactSavedCodes['Tools']}
              setSavedData={(newData: ICurrentVariant[]) => {
                const date = { ...state.contactSavedCodes }
                date['Tools'] = [...newData]
                updateContactSavedCodes(date)
              }}
              setUpdateData={(e: boolean) => {
                setIsUpdateDataTools(e)
              }}
              contactId={String(props.dialogEntryId)}
              readOnly={readOnly}
              type={'Tools'}
              HPID={state.entryIdItem.get('HPPassportProfileID')}
              checkFn={(value: string) => {
                const conditions = state.toolAccessConditions
                if (!conditions) {
                  return ''
                }
                const item = conditions.find((el) => el.Flag === value)
                if (item) {
                  return item.ConditionFullfilled ? '' : item.Comment
                }
                return ''
              }}
            />
          )}
        </>
      )}
      {tab === 4 && (
        <div>
          <ContactRelinking
            entryIdItem={entryIdItem}
            readOnly={readOnly}
            checkEmailValidation={checkEmailValidation}
            onChangeField={onChangeField}
            newPartnerId={state.contactWithMultiplePartners?.partnerId}
          />
        </div>
      )}
      {tab === 5 && (
        <EditProfile
          contact={replacementContact}
          onChangeField={onChangeFieldInReplacementContact}
          checkPhoneNumberValidation={checkPhoneNumberValidation}
          checkEmailValidation={checkEmailValidation}
          contactEditDialogState={state}
          contactEditDialogProps={props}
          checkFieldValidation={checkFieldValidation}
          changeCountyCode={changeCountyCode}
          setValidation={setValidation}
          setChangeStatus={setChangeStatus}
          setPreferredContact={setPreferredContact}
        />
      )}
      <ModalDialog
        size="sm"
        show={state.askCloseDialog}
        onClose={() => {
          let tempTab = tab
          if (state.isUpdateDataUserRigth) {
            tempTab = 1
          } else if (state.isUpdateDataCampaigns) {
            tempTab = 2
          } else if (state.isUpdateDataTools) {
            tempTab = 3
          } else if (state.modifiedFields.length) {
            tempTab = 0
          }
          setTab(tempTab)
          setAskCloseDialog(false)
        }}
        content={() => (
          <div style={{ fontWeight: 400, fontSize: '20px', textAlign: 'center' }}>
            <p>You have unsaved changes. Check other tabs.</p>
            {(() => {
              const items = []
              if (state.modifiedFields.length) {
                items.push(<p> - Edit Profile</p>)
              }
              if (state.isUpdateDataUserRigth) {
                items.push(<p> - User Rigth</p>)
              }
              if (state.isUpdateDataCampaigns) {
                items.push(<p> - Campaigns</p>)
              }
              if (state.isUpdateDataTools) {
                items.push(<p> - Tools</p>)
              }
              return items
            })()}
            <p>Close the dialog?</p>
          </div>
        )}
        footer={() => (
          <Actions
            position={'center'}
            items={[
              {
                id: 'no',
                label: 'No',
                variant: 'outlined',
                onClick: () => {
                  let tempTab = tab
                  if (state.isUpdateDataUserRigth) {
                    tempTab = 1
                  } else if (state.isUpdateDataCampaigns) {
                    tempTab = 2
                  } else if (state.isUpdateDataTools) {
                    tempTab = 3
                  } else if (state.modifiedFields.length) {
                    tempTab = 0
                  }
                  setTab(tempTab)
                  setAskCloseDialog(false)
                },
              },
              {
                id: 'yes',
                label: 'Yes',
                variant: 'outlined',
                color: 'danger',
                onClick: props.onClose,
              },
            ]}
          />
        )}
      />
    </>
  )
}
